import { render, staticRenderFns } from "./AddonActivationPayment.vue?vue&type=template&id=6116c58a&scoped=true&"
import script from "./AddonActivationPayment.vue?vue&type=script&lang=js&"
export * from "./AddonActivationPayment.vue?vue&type=script&lang=js&"
import style0 from "./AddonActivationPayment.vue?vue&type=style&index=0&id=6116c58a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116c58a",
  null
  
)

export default component.exports